import { useEffect, type RefObject } from 'react';

/**
 * Belirtilen ref disina tiklandiginda callback'i cagir.
 * Settings popup gibi panelleri kapatmak icin kullanilir.
 */
export function useOutsideClick(
  ref: RefObject<HTMLElement | null>,
  isOpen: boolean,
  onClose: () => void,
) {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [isOpen, ref, onClose]);
}
